<div class="apps-launcher-container">
  <button class="apps-launcher-btn" (click)="toggle()" title="Aplicaciones">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <circle cx="4" cy="4" r="2.5"/>
      <circle cx="12" cy="4" r="2.5"/>
      <circle cx="20" cy="4" r="2.5"/>
      <circle cx="4" cy="12" r="2.5"/>
      <circle cx="12" cy="12" r="2.5"/>
      <circle cx="20" cy="12" r="2.5"/>
      <circle cx="4" cy="20" r="2.5"/>
      <circle cx="12" cy="20" r="2.5"/>
      <circle cx="20" cy="20" r="2.5"/>
    </svg>
  </button>

  <div class="apps-launcher-dropdown" *ngIf="isOpen">
    <div class="apps-launcher-grid">
      <button class="app-tile" (click)="openRewards()" [disabled]="loading">
        <div class="app-icon rewards-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
        </div>
        <span class="app-name">Rewards</span>
      </button>
    </div>
    <div class="apps-launcher-error" *ngIf="error">{{ error }}</div>
  </div>
</div>
